import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.common.Avatar', {
    invitedUserTitle: '{name} has not yet accepted the invitation to this Organisation.',
    notInvitedUserTitle: '{name} has not yet been invited to this Organisation.',
    rejectedUserTitle: '{name} rejected the invitation to this Organisation.',
});
